import { ActivationMissingActions } from 'constants/ActionsTypesTs'
import {
	IConfirmMissingOrdersResponse,
	IConfirmMissingOrdersStatusResponse,
	IGetActivationMissingOrdersResponse
} from 'models/ActivationMissingOrders'
import { IResponseResult } from 'models/ResultsInterface'
import { AnyAction } from 'redux'

interface ActivationMissingState {
	missingOrdersData: IGetActivationMissingOrdersResponse | null
	selectedItems: IResponseResult | null
	confirmItems: IConfirmMissingOrdersResponse | null
	statusConfirmItems: IConfirmMissingOrdersStatusResponse | null
}

const initialState = {
	missingOrdersData: null,
	selectedItems: null,
	confirmItems: null,
	statusConfirmItems: null
}

function rootReducer(
	state: ActivationMissingState = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case ActivationMissingActions.GET_ACTIVATION_MISSING_ORDERS:
			return { ...state, missingOrdersData: null }
		case ActivationMissingActions.GET_ACTIVATION_MISSING_ORDERS_SUCCESS:
			return { ...state, missingOrdersData: action.payload }
		case ActivationMissingActions.SELECT_ACTIVATION_MISSING_ITEM:
			return { ...state, selectedItems: null }
		case ActivationMissingActions.SELECT_ACTIVATION_MISSING_ITEM_SUCCESS:
			return { ...state, selectedItems: action.payload }
		case ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_ITEMS:
			return { ...state, confirmItems: null }
		case ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_ITEMS_SUCCESS:
			return { ...state, confirmItems: action.payload }
		case ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS:
			return { ...state }
		case ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS_SUCCESS:
			return { ...state, statusConfirmItems: action.payload }
		case ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS_CLEAR:
		case ActivationMissingActions.CANCEL_ACTIVATION_MISSING_SUCCESS:
			return { ...state, statusConfirmItems: null }

		default:
			return state
	}
}

export default rootReducer
